function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.3165 18.4799V16.8199H5.87646V18.4799H10.6965V30.9999H12.5165V18.4799H17.3165Z",
  fill: "black"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.8788 30.9999L24.9388 22.4199L29.8588 16.8199H27.6588L21.2788 24.0999V16.8199H19.4788V30.9999H21.2788V26.5999L23.6788 23.8599L27.7788 30.9999H29.8788Z",
  fill: "black"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.7812 30.9999V29.3999H34.5412L39.3812 23.5399C40.1412 22.5999 40.5612 21.6799 40.5612 20.5799C40.5612 19.6999 40.3412 19.0199 39.9212 18.4199C39.2212 17.4399 37.9812 16.8199 36.4612 16.8199C34.0012 16.8199 32.3012 18.4599 32.3012 20.8799H34.0612C34.0612 19.0399 35.2412 18.3599 36.4812 18.3599C37.9412 18.3599 38.8212 19.1799 38.8212 20.5999C38.8212 21.3199 38.6012 21.9599 38.0612 22.5999L32.3212 29.5399V30.9999H40.7812Z",
  fill: "black"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 1H46V-1H2V1ZM47 2V46H49V2H47ZM46 47H2V49H46V47ZM1 46V2H-1V46H1ZM2 47C1.44772 47 1 46.5523 1 46H-1C-1 47.6569 0.343147 49 2 49V47ZM47 46C47 46.5523 46.5523 47 46 47V49C47.6569 49 49 47.6569 49 46H47ZM46 1C46.5523 1 47 1.44772 47 2H49C49 0.343145 47.6569 -1 46 -1V1ZM2 -1C0.343145 -1 -1 0.343147 -1 2H1C1 1.44772 1.44772 1 2 1V-1Z",
  fill: "#F2994A"
});

var SvgTk2Medium = function SvgTk2Medium(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTk2Medium, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TK2-medium.300dfa87.svg";
export { ForwardRef as ReactComponent };